/**
 * ShaderGradient の PC/モバイル共通プリセット
 * Landing / Pricing / Products で使用する CTA・Features 背景を一箇所で管理
 */

/** CTA 用 ShaderGradient の props（BG01）。isMobile で値が変わる項目のみ分岐 */
export function getCtaShaderProps(isMobile) {
  return {
    animate: 'on',
    axesHelper: 'off',
    bgColor1: '#000000',
    bgColor2: '#000000',
    brightness: 1.1,
    cAzimuthAngle: 180,
    cDistance: isMobile ? 6.4 : 3.3,
    cPolarAngle: 90,
    cameraZoom: 1,
    color1: '#e9e9ee',
    color2: '#e6e6ee',
    color3: '#55bbdd',
    destination: 'onCanvas',
    embedMode: 'off',
    envPreset: isMobile ? 'city' : 'lobby',
    format: 'gif',
    fov: isMobile ? 45 : 50,
    frameRate: 10,
    gizmoHelper: 'hide',
    grain: 'on',
    lightType: '3d',
    pixelDensity: 3,
    positionX: 0,
    positionY: 1.8,
    positionZ: 0.5,
    range: 'disabled',
    rangeEnd: 19.8,
    rangeStart: 0,
    reflection: 0.1,
    rotationX: isMobile ? 50 : 40,
    rotationY: 0,
    rotationZ: isMobile ? 75 : 64,
    shader: 'defaults',
    type: 'plane',
    uAmplitude: 1,
    uDensity: 7,
    uFrequency: 5.5,
    uSpeed: 0.3,
    uStrength: 0.4,
    uTime: 0,
    wireframe: false,
  };
}

/** Features 用 ShaderGradient の props（BG02）。isMobile で値が変わる項目のみ分岐 */
export function getFeaturesShaderProps(isMobile) {
  return {
    animate: 'on',
    axesHelper: 'on',
    bgColor1: '#000000',
    bgColor2: '#000000',
    brightness: isMobile ? 1.1 : 0.9,
    cAzimuthAngle: 180,
    cDistance: isMobile ? 3.91 : 3,
    cPolarAngle: 115,
    cameraZoom: 1,
    color1: isMobile ? '#6666ff' : '#6969ff',
    color2: isMobile ? '#2222ff' : '#7ddaff',
    color3: isMobile ? '#222222' : '#000000',
    destination: 'onCanvas',
    embedMode: 'off',
    envPreset: 'city',
    format: 'gif',
    fov: 45,
    frameRate: 10,
    gizmoHelper: 'hide',
    grain: 'off',
    lightType: '3d',
    pixelDensity: isMobile ? 2 : 3,
    positionX: isMobile ? 0 : -0.3,
    positionY: isMobile ? 0 : 0.1,
    positionZ: 0,
    range: 'disabled',
    rangeEnd: 40,
    rangeStart: 0,
    reflection: 0.1,
    rotationX: isMobile ? -28 : -20,
    rotationY: 0,
    rotationZ: isMobile ? 235 : -130,
    shader: 'defaults',
    type: 'waterPlane',
    uAmplitude: 0,
    uDensity: isMobile ? 3.5 : 1.5,
    uFrequency: 5.5,
    uSpeed: 0.1,
    uStrength: isMobile ? 2.6 : 3,
    uTime: 0.2,
    wireframe: false,
    zoomOut: false,
  };
}
